import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { FakeDropdown } from '../FakeDropdown/FakeDropdown';
import { ProductFilters } from '../ProductFilters/ProductFilters';
import { disableBodyScrolling } from '@/utils/disableBodyScrolling';
import { collection, CollectionState } from '@/services/collection';

@Component
export class CollectionFilteringSorting extends ThemeComponent {
    @Prop({ default: window.pageYOffset }) scrollPosition!: number;

    @Ref() sortBy!: FakeDropdown;
    @Ref() filterTogle!: HTMLElement;
    @Ref() filters!: ProductFilters;

    init() {

        // Give initial value for scrollPosition
        this.scrollPosition = window.pageYOffset;

        // Listen for sort by change
        this.$subscribe(this.sortBy.onChange, (value) => {
            this.sortByValueChanged(value);
        });

        // Init filter toggle click event listeners
        this.initFilterToggleClickEventListener();

        // Init mobile filter breakpoint check
        this.matchMedia();
    }

    sortByValueChanged(value: string) {

        // Define new state
        const state = collection.state;
        const newState: CollectionState = {
            ...state,
            sortBy: value,
            page: undefined,
        };

        // Load new section
        void collection.update(newState);
    }

    initFilterToggleClickEventListener() {
        this.$listen(this.filterTogle, 'click', () => {

            // Body class
            document.body.classList.toggle('product-filters-active');

            // Filters class
            this.filters.classList.toggle('product-filters--active');
        });
    }

    matchMedia() {

        // Remove product filters active active if greater than mobile breakpoint
        const mmBreakpoint = window.matchMedia(`(max-width: 768px)`);

        // Check breakpoint, remove product filters classes if required
        const breakpointChecker = () => {
            if (!mmBreakpoint.matches) {

                // Only run if filters are active
                if (!document.body.classList.contains('product-filters-active')) {
                    return;
                }

                // Enable body scrolling
                this.scrollPosition = disableBodyScrolling(false, this.scrollPosition);

                // Body class
                document.body.classList.remove('product-filters-active');

                // Filters class
                this.filters.classList.remove('product-filters--active');
            }
        };

        // Init listener and initial check
        breakpointChecker();
        mmBreakpoint.addListener(breakpointChecker);
    }
}
